import React, { createContext, useState } from 'react';

import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

export const UserGroupStateContext = createContext();

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE
};

const UserGroupContextProvider = ({ children }) => {
  const stateHook = useState(INITIAL_STATE);

  return (
    <UserGroupStateContext.Provider value={stateHook}>
      {children}
    </UserGroupStateContext.Provider>
  );
};

export default UserGroupContextProvider;